'use client';

import { Button } from '@personly/libs-widgets';
import { useMemo } from 'react';

import { useEmails } from '@/providers/emails';
import { usePasswords } from '@/providers/passwords';

interface Props {
  children: string;
}

const LoginSubmitButton = ({ children }: Props) => {
  const { email } = useEmails();
  const { password } = usePasswords();

  const isDisabled = useMemo(
    () => email.length === 0 || password.length === 0,
    [email.length, password.length]
  );

  return (
    <Button block type="submit" disabled={isDisabled}>
      {children}
    </Button>
  );
};

export default LoginSubmitButton;
